import EdazPhoneInput from "@edaz/edazkit/InputPhone";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Col, Form } from "react-bootstrap";
import { setVisitedProperty } from "utils/validationPatch";
import PersonViewModel from "viewModels/notice/components/personViewModel";
import EmailInput from "../../../common/emailInput/emailInput";

const ContactInput: FunctionComponent<{
  vm: PersonViewModel;
}> = observer(({ vm }) => {
  const ta = (code: string) => vm.translateAttribute("contact", code);
  return (
    <Form.Row>
      <EmailInput
        id="optional-email"
        xl={6}
        label={ta("classicOptionalEmail.email")}
        translate={ta}
        target={vm.person}
        property="emailAddress"
      />
      <Form.Group controlId="optional-phone-number" as={Col} sm={12} xl={6}>
        <Form.Label>{ta("classicOptionalPhoneNumber")}</Form.Label>
        <EdazPhoneInput
          id="optional-phone-number"
          target={vm.person}
          property="phoneNumber"
          defaultPrefix={vm.defaultPrefixNumber}
          placeholder={ta("phoneNumberPlaceholder")}
          onBlur={() => setVisitedProperty(vm.person, "phoneNumber")}
        />
      </Form.Group>
    </Form.Row>
  );
});

export default ContactInput;
